import _ from 'lodash';
import { Filters, SortingMethod } from '@common/types';
import {
  ACTIONS,
  useTemplatesContext,
} from '@components/Contexts/TemplatesContext';
import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKeyFrom } from '@utils/queryUtils';
import { TemplateQueryResponse } from '@common/types';
import { useErrorMonitor, useHttpClient } from '@wix/fe-essentials-standalone';

export const useInfiniteTemplatesQuery = (
  filters: Filters,
  sort: SortingMethod,
) => {
  const httpClient = useHttpClient();
  const errorMonitor = useErrorMonitor();
  const {
    dispatch,
    state: { currentPage },
  } = useTemplatesContext();

  return useInfiniteQuery({
    queryKey: queryKeyFrom(filters, 1, sort, true),
    queryFn: async ({
      pageParam = 1,
    }): Promise<TemplateQueryResponse | undefined> => {
      dispatch({
        type: ACTIONS.LOADING,
      });

      try {
        const { data } = await httpClient.post<TemplateQueryResponse>(
          '/api/templates',
          {
            ...filters,
            page: pageParam,
            sort,
          },
        );
        // dispatch({ type: ACTIONS.SET_PAGE, currentPage: currentPage + 1 });
        dispatch({
          type: ACTIONS.INITIALIZED,
        });
        return data;
      } catch (err) {
        errorMonitor.captureException(err as Error);

        dispatch({
          type: ACTIONS.ERROR,
        });
      }
    },
    getNextPageParam: (
      lastPage: TemplateQueryResponse | undefined,
      allPages,
    ) => {
      return lastPage?.hasNextPage ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
  });
};
